'use client'

import { useEffect, useState } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { getToken, getUser } from '@/lib/auth'

interface AuthGuardProps {
  children: React.ReactNode
  sidebar?: React.ReactNode
  requiredRole: 'admin' | 'judge'
  loginPath: string
}

export function AuthGuard({ children, sidebar, requiredRole, loginPath }: AuthGuardProps) {
  const router = useRouter()
  const pathname = usePathname()
  const [ready, setReady] = useState(false)
  const [authed, setAuthed] = useState(false)
  const isLoginPage = pathname === loginPath

  useEffect(() => {
    if (isLoginPage) {
      setReady(true)
      return
    }
    const token = getToken()
    const user = getUser()
    if (!token || !user || user.role !== requiredRole) {
      router.replace(loginPath)
    } else {
      setAuthed(true)
      setReady(true)
    }
  }, [requiredRole, loginPath, router, isLoginPage])

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  if (isLoginPage || !authed) {
    return <>{children}</>
  }

  return (
    <div className="flex min-h-screen">
      {sidebar}
      <main className="flex-1">{children}</main>
    </div>
  )
}
